export const BREADCRUMB_TEXTS = {
  label: 'Estás en:',
  current: 'Suscribir APV',
};
